export const AwardsManagementPermissions = {
    ViewAwardsManagement: {
    permissionsId: "73f97cc9-45d9-4f3c-7afa-08dd9056d268",
    permissionsName: "View Awards Management",
    description: null,
    componentsId: null,
    components: null,
  },
};
  